// Zentrale Konfiguration — Kontaktdaten & Texte hier einfach anpassen.
export const site = {
    studioName: "BVISION Designer Studio",
    shortName: "BVISION",
    owner: "Berkay Budak",
    role: "Mediengestalter & Gründer",
    email: "bvision.designer@hotmail.com",
    phone: "+49 151 67669607",
    address: "Unterer Grifflenberg 46, 42119 Wuppertal",
    socials: [
        { label: "Instagram", url: "https://www.instagram.com/bvision.designerstudio/" },
    ],
    disciplines: ["Visual Design", "Branding", "Social Media", "Editorial", "Photography", "Videography", "Creative Direction"],
    heroClaim: ["Ideen werden Visuals.", "Visuals werden Identität."],
    aboutText:
        "Ich bin Berkay Budak, Mediengestalter und Gründer von BVISION Designer Studio. Ich entwickle visuelle Konzepte, Markenidentitäten und digitale Designs mit dem Anspruch, Gestaltung nicht nur schön aussehen zu lassen, sondern ihr einen eigenen Charakter zu geben.",
    aboutText2:
        "Jedes Projekt beginnt mit einer Idee und endet mit einer visuellen Sprache, die im Gedächtnis bleibt — klar, mutig und unverwechselbar.",
    focus: [
        "Brand Identity",
        "Graphic Design",
        "Editorial Design",
        "Social Media Design",
        "Photography",
        "Videography",
        "Content Creation",
        "Creative Direction",
        "Digital Design",
    ],
    services: [
        { name: "Branding & Visual Identity", detail: "Logosysteme, Farbwelten, Design-Guidelines" },
        { name: "Logo Design", detail: "Zeichen mit Charakter und Wiedererkennungswert" },
        { name: "Graphic Design", detail: "Print, Poster, Kampagnen-Motive" },
        { name: "Editorial & Magazine Design", detail: "Layouts, Typografie-Systeme, Cover" },
        { name: "Social Media Design", detail: "Feeds, Templates, Content-Systeme" },
        { name: "Photography", detail: "Editorial, Porträt, Street & Produkt" },
        { name: "Videography", detail: "Cineastische Clips, Social Videos & Aftermovies" },
        { name: "Content Creation", detail: "Foto & Video, visuelles Storytelling" },
        { name: "Campaign Design", detail: "Kampagnen-Konzepte über alle Kanäle" },
        { name: "Creative Direction", detail: "Art Direction, Konzeption, Markenführung" },
        { name: "Digital Design", detail: "Webdesign, UI, digitale Touchpoints" },
    ],
    projectTypes: ["Branding", "Editorial", "Social Media", "Fotografie", "Videografie", "Kampagne", "Digital", "Sonstiges"],
    budgets: ["< 1.000 €", "1.000 – 3.000 €", "3.000 – 7.500 €", "7.500 € +"],
    portrait: "/media/portrait.jpg",
};
